import { ref } from 'vue';
import billingResource from '@/apps/admin/billing/resources/billing';
import { downloadBlob } from '@/commons/services/files';
import { useToaster } from '@/commons/composables/useToaster';
import { getMessage } from '@/commons/services/error';

export function useBilletDownload() {
  const toaster = useToaster();
  const downloadingIds = ref([]);

  const isDownloading = invoiceId => {
    return downloadingIds.value.includes(invoiceId);
  };

  const download = async invoiceId => {
    if (!String(invoiceId ?? '').trim() || isDownloading(invoiceId)) {
      return;
    }

    downloadingIds.value.push(invoiceId);

    try {
      const blob = await billingResource.getBilletPdf(invoiceId);

      await downloadBlob(blob, `boleto-${invoiceId}.pdf`);
    } catch (error) {
      toaster.error(getMessage(error) || 'Não foi possível baixar o boleto. Tente novamente.');
    } finally {
      downloadingIds.value = downloadingIds.value.filter(id => id !== invoiceId);
    }
  };

  return {
    isDownloading,
    download
  };
}
